import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { CompanyDetailsType } from "../../types/paymentTypes";
import { checkTokenValidation } from "../auth/tokenReq";

export const getCepDashboardStatsReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": dashboardStatsReq->getDashboardStatsReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.cepDashboardStatsKey}`);
    // logfun(res.data, "res");
    const resData = res.data.company;
    const _msg = res?.data?.message || "";
    const _data = {
      numberOfCandidateOffers: resData?.totalOffers || "0",
      numberOfCandidates: resData?.candidatesCount || "0",
      numberOfCompanies: resData?.companyAssigned || "0",
      numberofCardsets: resData?.totalCardSets || "0",
      joinedCandidatesCount: resData?.joinedCandidatesCount || "0",
      joinersPercentage: resData?.joinedPercentage || "0",
      dropoutCandidatesCount: resData?.dropoutCandidatesCount || "0",
      dropoutPercentage: resData?.dropoutPercentage || "0",
      companyDetails: resData?.companyDetails?.map((item: any) => ({
        companyID: item?.company?.companyID || "",
        companyName: item?.company?.CompanyName || "",
        companyWebLogoURL: item?.company?.companyWebLogoURL || "",
        companyLogoURL: item?.company?.companyLogoURL || "",
        Status: item?.company?.Status || "",
        userCount: item?.userCount || "",
        candiadteCount: item?.candidateCount || "",
        activeOfferedCandidatesCount: item?.activeOfferedCandidatesCount || "",
      })),
    };
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
